import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider, signInWithPopup, signOut } from 'firebase/auth';

import { env } from './env';

const app = initializeApp({
  apiKey: env.VITE_FIREBASE_API_KEY,
  authDomain: env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: env.VITE_FIREBASE_APP_ID,
});

export const firebaseAuth = getAuth(app);
const googleProvider = new GoogleAuthProvider();

/** Open Google popup, return the Firebase idToken to exchange with our backend. */
export async function signInWithGoogle(): Promise<string> {
  const cred = await signInWithPopup(firebaseAuth, googleProvider);
  return cred.user.getIdToken();
}

export async function firebaseSignOut(): Promise<void> {
  await signOut(firebaseAuth);
}
